 import React,{useEffect} from 'react';
 import { useNavigate } from 'react-router-dom';
 
 function Logout() {
     const navigate = useNavigate();
     useEffect(() => {
       const authToken = sessionStorage.clear();
       if(!authToken){
         navigate('/');
       }
     });
     
   return (
     <></>
   )
 }
 
 export default Logout
 